<script setup>
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const props = defineProps({
    item: {
      type: Object,
      required: true
    }
  });
</script>

<template>
  <ul class="cart-item-isbns list-unstyled mb-0 mt-1">
    <li class="isbn-item">
      {{ t('cart.isbn') }}
      <span class="cart-item-isbn-format">{{ item.offer.format.toUpperCase() }}</span>:
      <span class="cart-item-isbn">{{ item.publication.isbn }}</span>
    </li>
    <li v-if="item.publication.print_isbn" class="isbn-item">
      {{ t('cart.paper_isbn') }} <span class="cart-item-paper-isbn">{{ item.publication.print_isbn }}</span>
    </li>
    <li v-if="item.offer.external_identifier" class="isbn-item">
      {{ t('cart.offer_isbn') }} <span class="cart-item-offer-isbn">{{ item.offer.external_identifier }}</span>
    </li>
  </ul>
</template>

<style scoped>
  .isbn-item {
    font-size: 14px;
  }
</style>
